/* eslint-disable no-underscore-dangle */
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {makeSelectCreate} from 'reducers/selectors/fileSelector';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {
  addUploadedFile,
  copyFolder,
  createFolder,
  deleteFolder,
  fetchFolder,
  fetchFolders,
  fetchFolderSuccess,
  moveFolder,
  updateFolder,
} from 'actions/documentsActions';
import history from 'utils/history';
import CheckIcon from 'assets/svgs/actions/confirm-delete-check.svg';
import ClearIcon from 'assets/svgs/actions/clear.svg';
import {BASE_API_URL} from 'config';
import TrashIcon from 'assets/svgs/actions/trash.svg';
import IconModal from 'components/IconModal';
import {useContextMenu} from 'react-contexify';
import SingleContextMenu from './SingleContextMenu';
import FileUploadModal from './FileUploadModal';
import FileOperation from './FileOperation';
import PostsFooter from './PostFooter';
import FilesTable from './FilesTable';
import Search from './Search';
import './style.scss';
import 'styles/blog-post-edit.scss';

const basicUserSelector = makeSelectBasicUser();

const Overview = ({folderId}) => {
  const [selected, setSelected] = useState([]);
  console.log(folderId, 'folderId');
  const dispatch = useDispatch();
  const iframe = useRef();
  const posts = useSelector((state) => state.documents);
  const basicUser = useSelector(basicUserSelector);
  const {insideFolder} = posts;
  const [uploadFiles, setUploadFiles] = useState(null);
  const folderState = useSelector(makeSelectCreate());
  const [breadcrumb, setBreadcrumb] = useState([]);
  const [contextData, setContextData] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [fileOperations, setFileOperations] = useState(null);
  const [pageFilter, setPageFilter] = useState({
    pageSize: 200,
    pageNumber: 0,
  });
  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    post: null,
  });
  const {show} = useContextMenu({
    id: 'FILEMENU',
  });

  const handleContextMenu = (event, data) => {
    show(event);
    setContextData(data);
  };

  useEffect(() => {
    setTimeout(() => fetch(), 200);
  }, [insideFolder, pageFilter, searchKey]);

  useEffect(() => {
    if (insideFolder && !breadcrumb.find((f) => f._id === insideFolder._id)) {
      setBreadcrumb([...breadcrumb, insideFolder]);
    }
  }, [insideFolder]);

  useEffect(() => {
    if (folderId) {
      setTimeout(() => dispatch(fetchFolder(folderId)), 200);
    }
  }, []);

  const fetch = () => {
    const params = {
      ...pageFilter,
    };
    if (insideFolder) {
      params.folderId = insideFolder._id;
    }
    dispatch(fetchFolders(params));
  };

  return (
    <>
      <iframe
        title="test"
        id="my_iframe"
        ref={iframe}
        style={{display: 'none'}}
      ></iframe>

      <SingleContextMenu
        data={contextData}
        onHidden={() => setContextData(null)}
        selected={selected}
        onClick={(data) => {
          switch (data.type) {
            case 'download':
              iframe.current.setAttribute(
                'src',
                `${BASE_API_URL}company/${data._id}/download`
              );
              break;
            case 'delete':
              setDeleteConfirm({isOpen: true, post: data});
              break;

            case 'color':
              dispatch(
                updateFolder(
                  data._id,
                  {colour: data.colour},
                  'Changed the color'
                )
              );
              break;
            case 'star':
              dispatch(
                updateFolder(
                  data._id,
                  {
                    isStar: !data.isStar,
                  },
                  data.isStar
                    ? 'Favorite the file'
                    : 'Removed the file from favorite'
                )
              );
              break;

            case 'copy':
              dispatch(copyFolder(data._id));
              break;
            default:
              setFileOperations(data);
              break;
          }
        }}
      />
      {fileOperations && (
        <FileOperation
          file={fileOperations}
          breadcrumb={breadcrumb}
          selected={insideFolder}
          list={selected}
          userDetails={basicUser}
          companyId={null}
          onMove={(folder, file) => {
            dispatch(moveFolder(file._id, folder._id));
            setFileOperations(null);
          }}
          onGroup={(folder) => {
            selected.forEach((file) => {
              dispatch(moveFolder(file._id, folder ? folder._id : null));
            });
            setFileOperations(null);
            setSelected([]);
          }}
          onUpdate={(update) => {
            dispatch(
              updateFolder(
                update._id,
                update.details,
                `Renamed from ${update.oldName} to ${update.details.name}`
              )
            );
            setFileOperations(null);
          }}
          onClose={() => setFileOperations(null)}
        />
      )}
      {uploadFiles && (
        <FileUploadModal
          folderState={folderState}
          breadcrumb={breadcrumb}
          selected={insideFolder}
          onClose={() => {
            setUploadFiles(false);
          }}
          onAddFolder={(name) => {
            const obj = {name};
            const filters = {};
            if (insideFolder) {
              filters.folderId = insideFolder._id;
            }

            if (breadcrumb.length > 0) {
              filters.parentId = breadcrumb[0]._id;
            } else if (insideFolder) {
              filters.parentId = insideFolder._id;
            }

            obj.categoryType = 'DOCUMENT';
            dispatch(createFolder(null, obj, filters));
            setUploadFiles(false);
          }}
          onFileUpload={(file) => {
            if (file) {
              dispatch(addUploadedFile(file));
            }
          }}
        />
      )}

      <div className="tab-box">
        <div className="d-flex mob-flex">
          <div className="tab-content bg-white w-100">
            <Search
              tab={{label: 'Documents'}}
              setSearchKey={setSearchKey}
              searchKey={searchKey}
              onChange={(search) => {
                const newPageFilter = {...pageFilter};
                newPageFilter.searchKey = search;
                setPageFilter(newPageFilter);
              }}
              breadcrumb={breadcrumb}
              selected={insideFolder}
              onFile={() => setUploadFiles(true)}
              onClick={(folder) => {
                if (!folder) {
                  dispatch(fetchFolderSuccess(null));
                  setBreadcrumb([]);
                } else {
                  const newBreadCrumb = [];
                  breadcrumb.every((f) => {
                    if (f._id !== folder._id) {
                      newBreadCrumb.push(f);
                      return true;
                    }
                    newBreadCrumb.push(f);
                    return false;
                  });

                  setBreadcrumb(newBreadCrumb);
                  dispatch(fetchFolderSuccess(folder));
                }
              }}
            />

            {posts.fetchSuccess && (
              <>
                <FilesTable
                  selected={selected}
                  inside={breadcrumb[0]}
                  onDoubleClick={(file) => {
                    if (file.folderType === 'FOLDER') {
                      setSearchKey('');
                      const newBreadCrumb = [...breadcrumb];
                      newBreadCrumb.push(file);
                      setBreadcrumb(newBreadCrumb);
                      dispatch(fetchFolderSuccess(file));
                      setSelected([]);
                      history.push(`/admin/documents/${file.uniqueId}`);
                    }
                  }}
                  setSelected={(file) => {
                    let newSelected = [...selected];
                    const exists = newSelected.find((f) => f._id === file._id);

                    if (exists) {
                      newSelected = newSelected.filter(
                        (f) => f._id !== file._id
                      );
                    } else {
                      newSelected.push(file);
                    }
                    setSelected(newSelected);
                  }}
                  contextData={contextData}
                  handleContextMenu={handleContextMenu}
                  posts={posts.folders}
                  basicUser={basicUser}
                />
                {breadcrumb.length === 0 && (
                  <PostsFooter
                    pageFilter={pageFilter}
                    setPageFilter={setPageFilter}
                    count={50}
                    onChange={() => {}}
                  />
                )}
                <IconModal
                  isOpened={deleteConfirm.isOpen}
                  Icon={TrashIcon}
                  body={
                    <div className="d-flex flex-column">
                      {deleteConfirm.post && (
                        <>
                          <p className="mb-0 font-12">
                            {deleteConfirm.post.isDeleted
                              ? `This file/folder will be deleted permanentlly,`
                              : `This file/folder will be moved to trash,`}
                          </p>
                          <p>Are you sure you want to delete it?</p>
                        </>
                      )}

                      <div className="d-flex justify-content-between w-100">
                        <button
                          type="button"
                          className="cat-delete"
                          onClick={() => setDeleteConfirm({isOpen: false})}
                        >
                          <img src={ClearIcon} alt="test" className="mr-2" />
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="ml-auto cat-delete"
                          onClick={() => {
                            if (deleteConfirm.post.isDeleted) {
                              dispatch(deleteFolder(deleteConfirm.post._id));
                            } else {
                              dispatch(
                                updateFolder(
                                  deleteConfirm.post._id,
                                  {isDeleted: true},
                                  'Moved to trash'
                                )
                              );
                            }
                            setDeleteConfirm({isOpen: false, post: null});
                          }}
                        >
                          <img src={CheckIcon} alt="" className="mr-2" />
                          Confirm
                        </button>
                      </div>
                    </div>
                  }
                  onClose={() => {
                    setDeleteConfirm(false);
                  }}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Overview;
